import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { COLOR_PALETTE } from 'constants/ui';

const categoryStyles = { color: COLOR_PALETTE.GRAY[7] };

const TaskTypeOption = ({ option, optionText }) => (
  <div className="flex flex-col">
    <Typography data-truncated className="truncate" variant="regular16">
      {optionText}
    </Typography>
    {option.categoryName && (
      <Typography className="truncate" sx={categoryStyles} variant="regular12">
        {option.categoryName}
      </Typography>
    )}
  </div>
);

TaskTypeOption.propTypes = {
  option: PropTypes.object.isRequired,
  optionText: PropTypes.string.isRequired,
};

export default memo(TaskTypeOption);
